import { AxiosInstance } from 'axios';
import {
  SleepingConditionRepository,
} from '@/model/repository/manager/dailyCheck/sleeping/condtion/repostiory';

export default (axios: AxiosInstance) =>
  (resource: string): SleepingConditionRepository => ({
    async get({ groupId, date }) {
      const formattedDate = adaptDate(date);
      const {status, data} = await axios.get<Response>(`${resource}/sleeping/groups/${groupId}/conditions/${formattedDate}`);
      if (status !== 200) {
        throw new Error(`Failed to fetch sleeping condition: ${status}`);
      }
      return adaptResponse(data);
    },
    async put({groupId, date, weather, temperature, humidity}) {
      const formattedDate = adaptDate(date);
      const {status, data} = await axios.put<Response>(`${resource}/sleeping/groups/${groupId}/conditions/${formattedDate}`, {
        weather: weather === undefined ? null : weather,
        temperature: temperature === undefined ? null : temperature,
        humidity: humidity === undefined ? null : humidity,
      }, {
        validateStatus: () => true, // Always resolve promise to handle errors in catch block
      });
      if (status > 201) {
        throw { status };
      }
      return adaptResponse(data);
    }
  });

  type Response = {weather: string | null, temperature: string | null, humidity: string | null}

  const adaptDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const adaptResponse = ({weather, temperature, humidity}: Response) => ({
    weather: weather ?? undefined,
    temperature: temperature ?? undefined,
    humidity: humidity ?? undefined,
  });